import { ArrowUpRightSquare } from "react-bootstrap-icons";
import React from "react";

// This component will be rendered instead of links (such as link to resume) in Ag-Grid
// It provides an anchor element with generic "Open Link" text.
// When clicked, it will open the link in a new tab.
export const linkMask = ({ value }) => {
  return value ? (
    <a href={value} target="_blank" rel="noopener noreferrer">
      Open Link <ArrowUpRightSquare />
    </a>
  ) : (
    ""
  );
};
